const Colors = {
    yellow1 : '#FFF3DA',
    yellow2 : '#FFEECC',
    pink : '#FFEADD',
    button : '#FF986C',
    shadow : 'rgb(0, 0, 0, 0.25)',
    black : '#222222',
    white : '#FFFFFF',
}

export default Colors;